<template>
  <div class="mt-3">
    <ValidationObserver v-slot="{ invalid }">
      <form ref="form" @submit.prevent="openDropMap">
        <!-- <div class="form-group feedback-input">
          <h4>{{ $t("Please Enter Receiver Information") }}</h4>
        </div> -->

        <validation-provider
          v-slot="{ errors }"
          rules="required"
          name="NameReciever"
        >
          <div class="form-group">
            <label>{{ $t("Name Receiver") }}</label>
            <input
              v-model="model.receiver_name"
              type="text"
              class="form-control"
              :placeholder="$t('Name Receiver')"
            />
            <span class="error">{{ errors[0] }}</span>
          </div>
        </validation-provider>

        <validation-provider
          v-slot="{ errors }"
          rules="required|numeric"
          name="phoneNumber"
        >
          <div class="form-group">
            <label>{{ $t("Phone Number") }}</label>
            <input
              v-model="model.customer_phone_number"
              type="text"
              class="form-control"
              :placeholder="$t('enter_phone_number')"
            />
            <span class="error">{{ errors[0] }}</span>
          </div>
        </validation-provider>
        <!-- <button
          type="submit"
          :disabled="invalid"
          class="btn btn-brand btn-md mt-3"
        >
          <base-icon icon_name="arrow-right-circle" />
          {{ $t("Drop Location") }}
        </button> -->
      </form>
    </ValidationObserver>
  </div>
</template>
<script>
import store from "@/store";
export default {
  name: "BaseDelivery",
  data() {
    return {
      model: {
        customer_phone_number: "",
        receiver_name: "",
        lat: 0,
        lng: 0,
      },
    };
  },
  computed: {
    order_info() {
      return store.getters["order/order_info"];
    },
    btn_state() {
      return store.getters["location_selected/btnState"];
    },
    placeSelected() {
      return store.getters["location_selected/placeSelected"];
    },
  },
  mounted() {
    this.loadData();
    this.fill_data_to_model();
  },
  methods: {
    loadData() {
      this.model = this.order_info;
    },
    fill_data_to_model() {
      this.model.customer_phone_number = this.order_info.customer_phone_number;
      this.model.receiver_name = this.order_info.receiver_name;
    },
    async openDropMap() {
      this.$store.dispatch("order/setOrderInfo", this.model);
      this.$router.push({ name: "select_map" });
    },
  },
};
</script>